import { render } from "./HeroiconsOutlineWifi.vue?vue&type=template&id=9158bdf4"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineWifi.vue"]])

export default __exports__